import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "rows"]

  connect() {
    this.timeout = null
  }

  filter() {
    // Cancelar el timeout anterior si existe
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Esperar 300ms después de que el usuario deje de escribir
    this.timeout = setTimeout(() => {
      this.performFilter()
    }, 300)
  }

  performFilter() {
    const filterValue = this.inputTarget.value.toLowerCase()
    const rows = this.rowsTarget.querySelectorAll('tr[data-gas-station-table-search-target="row"]')
    
    rows.forEach(row => {
      // Buscar en múltiples columnas: nombre (columna 1), razón social (columna 2), RUC (columna 3), ciudad (columna 5)
      const name = row.cells[1]?.textContent.toLowerCase() || ''
      const socialReason = row.cells[2]?.textContent.toLowerCase() || ''
      const ruc = row.cells[3]?.textContent.toLowerCase() || ''
      const city = row.cells[5]?.textContent.toLowerCase() || ''
      
      const shouldShow = name.includes(filterValue) || 
                        socialReason.includes(filterValue) || 
                        ruc.includes(filterValue) || 
                        city.includes(filterValue)
      row.style.display = shouldShow ? "" : "none"
    })
  }
}
